import React from 'react';
import { Box, Card, Skeleton } from '@mui/material';
import ArgonBox from '../ArgonBox';

const FacturaSkeleton = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
        paddingBottom: "100px"
      }}
    >
      {/* Header skeleton */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "400px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "40px",
          marginTop: "20px",
          position: "relative",
        }}
      >
        <Skeleton
          variant="text"
          width={180}
          height={40}
          sx={{
            backgroundColor: '#f0f0f0',
            borderRadius: '8px'
          }}
        />
        <Skeleton
          variant="circular"
          width={32}
          height={32}
          sx={{
            backgroundColor: '#f0f0f0',
            position: 'absolute',
            right: 0,
            top: 0
          }}
        />
      </Box>

      {/* Card principal skeleton */}
      <Card sx={{ 
        width: '100%', 
        maxWidth: 400, 
        borderRadius: '16px', 
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        marginTop: "130px"
      }}>
        <ArgonBox p={4}>
          {/* Área de dropzone skeleton */}
          <Box
            sx={{
              border: '2px dashed #E0E0E0',
              borderRadius: '12px',
              padding: '32px 20px',
              textAlign: 'center',
              backgroundColor: '#F8F9FA',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            
            <Skeleton variant="text" width={200} height={20} />
            <Skeleton variant="text" width={120} height={16} />
          </Box>

   
      
        </ArgonBox>
      </Card>
    </Box>
  );
};

export default FacturaSkeleton;
